import React, { Component } from 'react';
import {darkMode, cleanPath} from '../../Utils.js';
import { SRLWrapper } from "simple-react-lightbox-pro";
import {Videoplayer} from '../../components/Videoplayer/Videoplayer.js'
import {Modularcontent} from '../../components/Modularcontent/Modularcontent.js'
import {Link} from "react-router-dom";
import TitleLoop from '../../components/TitleLoop/TitleLoop.js'

import './WorkSingle.scss';

export class WorkSingle extends Component {

  constructor(props) {
    super(props);

    let darkMode = false;
    let currentSlug = window.location.pathname;
    let windowWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);


    this.state = { data: {}, loaded: false, currentProject : false, nextProject : false, isLoadingNextProject : false, darkMode : darkMode, creditsOn: false, slug : currentSlug, windowWidth: windowWidth};
    this.getCurrentProject = this.getCurrentProject.bind(this);
    this._clickNextProject = this.clickNextProject.bind(this);

    this.nextProjectRef = React.createRef();
    this.nextProjectImageRef = React.createRef();

  }

  escFunction(event){
    if(event.keyCode === 27) {
      this.setState({creditsOn: false})
    }
  }

  componentDidMount() {
    document.getElementsByClassName('site__scrollable')[0].scrollTop = 0;

    darkMode(this.state.darkMode);
    this.getCurrentProject();
    this.setState({slug : window.location.pathname})

    document.addEventListener("keydown", this.escFunction.bind(this), false);
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  componentDidUpdate(prevProps, prevState) {
    const currentLocation = window.location.pathname;
    const locationChanged = prevState.slug !== currentLocation;
    if (locationChanged) {
      
      if (prevState.slug.includes('credits') && this.state.creditsOn) {
        // Credits back
        this.setState({creditsOn: false, slug: prevState.slug})
      } else if (currentLocation.includes('credits') && !this.state.creditsOn) {
          // Credits foward
          this.setState({creditsOn: true, slug: currentLocation})
      } else {
        // new project by url
        darkMode(this.state.darkMode);
        if (!this.state.isLoadingNextProject) {
          document.getElementsByClassName('site__scrollable')[0].scrollTop = 0;
  
          this.getCurrentProject();
          this.setState({slug : window.location.pathname})
        }
      }

    }
    let windowWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const windowWidthChanged = prevState.windowWidth !== windowWidth;
    if (windowWidthChanged) {
      this.setState({windowWidth : windowWidth});
    }

    const isCreditsChange = prevState.creditsOn !== this.state.creditsOn;
    if (isCreditsChange) {
      if (!prevState.creditsOn && this.state.creditsOn && !currentLocation.includes('credits')) {
        const state = {}
        const title = ''
        const url = window.location.pathname+'credits/'
        window.history.pushState(state, title, url);
        this.setState({slug: url})
      }
    }
  }

  loadingNexProject() {
    this.setState({isLoadingNextProject : false})
  }

  clickNextProject() {

    this.setState({isLoadingNextProject : true});
    let _that = this;
    //this.setState({currentProject : false, isLoadingNextProject : true});

    setTimeout(function() {
      _that.setState({currentProject : false, isLoadingNextProject : false});
    }, 2000)

  }

  getCurrentProject() {
    let allProjects = this.props.projects;

    const currentSlug = window.location.pathname;

    allProjects.map((project, index) => {
      if (currentSlug.includes(project.slug)) {
        this.setState({currentProject : project});
        let next_project_id = (typeof project.acf.worksingle_related !== 'undefined') ? project.acf.worksingle_related.ID : 0;

        this.getNextProject(next_project_id);
      }
    })
  }

  getNextProject(id) {
    let allProjects = this.props.projects;
    allProjects.map((project, index) => {
      if (id === project.id) {
        let nextProject = {};
        nextProject.title = project.title.rendered;
        nextProject.description = project.content.rendered;
        nextProject.url = cleanPath(project.link);
        nextProject.slug = project.slug;
        //nextProject.featured_image = project['featured_image_url'];
        nextProject.featured_image = (project.acf.worksingle_main_media) ? project.acf.worksingle_main_media.worksingle_featured_image['url'] : project['featured_image_url'];

        this.setState({nextProject : nextProject, loaded: true});
        return false;
      }
    })
    this.setState({loaded: true});

  }


  render() {

    if (this.state.currentProject) {
      let currentProject = this.state.currentProject;
      let title = currentProject.title.rendered;
      let content = currentProject.content.rendered;

      let next_title = 'Next Project';
      let next_project = false;

      let custom_fields = currentProject.acf;
      let modular_content, credits, related, videourl, mainimage, mainimageurl = false;

      if (custom_fields) {
        modular_content = custom_fields.worksingle_content;
        credits = custom_fields.worksingle_credits;
        related = custom_fields.worksingle_related;
        videourl = (custom_fields.worksingle_main_media && custom_fields.worksingle_main_media.worksingle_video_upload) ? custom_fields.worksingle_main_media.worksingle_video_upload.url : (custom_fields.worksingle_main_media && !custom_fields.worksingle_main_media.worksingle_video_upload) ? custom_fields.worksingle_main_media.worksingle_videourl : false;
        mainimage = (custom_fields.worksingle_main_media) ? custom_fields.worksingle_main_media.worksingle_featured_image : false;
        mainimageurl = (mainimage) ? mainimage['url'] : (currentProject['featured_image_url']) ? currentProject['featured_image_url'] : false;
        next_project = custom_fields.worksingle_related;
      }

      let creditsOnClass = (this.state.creditsOn) ? 'active' : '';


      if (this.state.creditsOn) {
        document.body.classList.add('body--creditsOn');
      } else {
        document.body.classList.remove('body--creditsOn');
      }

      const optionsLightbox = {
        settings: {
          slideAnimationType	: "both",
          autoplaySpeed: 1500,
          transitionSpeed: 900,
          overlayColor: "#080808",
        },
        buttons: {
          backgroundColor : "#080808",
          iconColor : "#ffffff",
          showAutoplayButton : false,
          showDownloadButton : false,
          showThumbnailsButton : false,
          showFullscreenButton : false,
          size : "32px"
        },
        caption: {
          showCaption: false
        },
        thumbnails: {
          showThumbnails: false
        },
        icons : {
          closeIcon: "/wp-content/themes/nachovelascotheme/media/close.png",
          previousIcon: "/wp-content/themes/nachovelascotheme/media/arrow-left.svg",
          nextIcon: "/wp-content/themes/nachovelascotheme/media/arrow-right.svg"
        }
      };

      let maxHeightInit = (this.state.windowWidth > 800) ? 500 : (this.state.windowWidth <= 800 && this.state.windowWidth > 520) ? 380 : 280;
      let offsetTopDiff = (this.state.windowWidth > 679) ? 140 : 110;
      let maxheight = (this.state.isLoadingNextProject) ? 3000 : maxHeightInit;
      let offsetTop  = (this.state.isLoadingNextProject) ? document.getElementsByClassName('module--nextproject')[0].getElementsByClassName('module__body')[0].getBoundingClientRect().top - offsetTopDiff : 0;
      let opacity = (this.state.isLoadingNextProject) ? 0 : 1;

      return (
        <main>
          <article className="module module--worksingle" style={!this.state.creditsOn && this.state.isLoadingNextProject ? {transform: 'translateY(' + -offsetTop +'px)', opacity: opacity} : null}>
            <div className="module__inner">
              <div className="module__body" data-scroll data-scroll-class="inview">
                <div className="module__body__inner">
                  {(videourl) &&
                    <Videoplayer url={videourl} loop={false} controls={true} preview={mainimageurl} />
                  || (!videourl && mainimageurl) &&
                    <img src={mainimageurl} alt={""} className="module--worksingle__mainimage"/>
                  }
                  <div className="module__body__content">
                    <div className="module__body__content__inner">
                      <div className="module__body__content__section module__body__content__section--1">
                        <h1 className="title title--2" dangerouslySetInnerHTML={{__html: title}}></h1>
                        {credits &&
                          <div className="credits__wrapper">
                            <button className="button button--2" onClick={() => this.setState({creditsOn: true})}>See credits</button>
                            <div className={`credits ${creditsOnClass}`}>
                              <div className="credits__inner">
                                <button className="button credits__close" onClick={() => this.setState({creditsOn: false})}>Close</button>
                                <ul className="credits__list" style={{minHeight : credits.length * 55 + 'px'}}>
                                  {credits.map((credit, index) => {
                                    return (
                                      <li className="credits__list__item" key={index}><span className="credits__list__item__title">{credit.worksingle_credits_title}</span> <span className="credits__list__item__names" dangerouslySetInnerHTML={{__html: credit.worksingle_credits_people}}></span></li>
                                    )
                                  })
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <div className="module__body__content__section module__body__content__section--2">

                      <div className="htmlcontent htmlcontent--2" dangerouslySetInnerHTML={{__html: content}} />

                      </div>

                    </div>
                  </div>
                  <SRLWrapper options={optionsLightbox}>
                  {modular_content && modular_content.map((content, index) => {
                    return (
                      <Modularcontent content={content} key={index} />
                    )
                  })
                  }
                  </SRLWrapper>
                </div>
              </div>
            </div>
          </article>


          {next_project && this.state.nextProject &&
            <div className="module module--nextproject" style={{transform: 'translateY(' + -offsetTop +'px)', maxHeight : maxheight + 'px'}} ref={this.nextProjectRef}>
              <div className="module__inner">
                <div className="module__header" style={{opacity:  opacity}}>
                  <div className="module__header__inner">
                    <h3 className="module__header__title ">
                      <TitleLoop title={next_title} />

                    </h3>
                  </div>
                </div>
                <div className="module__body" data-scroll data-scroll-class="inview">
                  <div className="module__body__inner">
                    <div className="nextprojectcard">
                      <Link to={this.state.nextProject.url} href={this.state.nextProject.url} className="nextprojectcard__inner" onClick={this._clickNextProject}>
                        <div className="nextprojectcard__media">
                          <img src={this.state.nextProject.featured_image} alt={this.state.nextProject.title} ref={this.nextProjectImageRef}/>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

        </main>
      )
    } else {
      return (
        <main></main>
      )
    }

  }
}
